  <template>
      <b-table
      
        :items="datos" 
        :fields="fields" 
    
        :current-page="currentPage"
        :per-page="perPage"
    
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
      <template #head()="{ label, field: { key, sortable }}">
          {{ label }}
        
          <template v-if="sortable">

              <!-- Custom icons -->
              <template v-if="useCustomIcons">
                <b-icon v-if="sortBy !== key" icon="arrow-down-up"></b-icon>
                <b-icon v-else-if="sortDesc" icon="arrow-down"></b-icon>
                <b-icon v-else icon="arrow-up"></b-icon>
              </template>

              <!-- Normal icons -->
              <template v-else>
                <b-img v-if="sortBy !== key" :src="sortIconNeutral" style="width: 0.65rem; height: 1rem;"></b-img>
                <b-img v-else-if="sortDesc" :src="sortIconAsc" style="width: 0.65rem; height: 1rem;"></b-img>
                <b-img v-else :src="sortIconDesc" style="width: 0.65rem; height: 1rem;"></b-img>
              </template>
      </template>
      
        
      </template>
      
      <template #head(titulo)="scope">
          <div style="width:250px">
              {{ scope.label }}
              <multiselect 
                  v-model="titulo" 
                  :options="titulos" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true" 
                  
                  label="nombre"
                  track-by="nombre"
                  >
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                      <span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} seleccionado</span>
                  </template>
              </multiselect>
              
          </div>
            
      </template>
      <template #head(estatus)="scope">
          <div style="width:150px">
              {{ scope.label }}
              <multiselect 
                  v-model="estado" 
                  :options="estados" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true" 
                  
                  label="nombre"
                  track-by="nombre"
                  >
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                      <span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} seleccionado</span>
                  </template>
              </multiselect>
          </div>
      </template>
          
      <template v-slot:cell(acciones)="row">
          <b-button :disabled="isDisabled(row.item)" size="sm" class="mb-1 mr-1"
            @click="attendant(row.item, row.index, $event.target)" data-toggle="tooltip" data-placement="top"
            title="atender el ticket">

            <i class="fa fa-handshake-o" aria-hidden="true"></i>

          </b-button>
          <!--
          <b-button size="sm" class="mb-1  mr-1" @click="callImageModal(row.item, row.index, $event.target)"
            data-toggle="toottip" data-placement="top" title="agregar una imagen al ticket">

            <i class="fa fa-camera" aria-hidden="true"></i>

          </b-button>
          -->
          

        </template>

        <template v-slot:cell(images)="row">
          <b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
            <i class="fa fa-eye" aria-hidden="true"></i>
          </b-form-checkbox>
        </template>

        <template v-slot:cell(estatus)="row">
          <div v-if="row.item.estatus == 'Abierto'">
            <b-badge pill variant="danger">{{row.item.estatus}}</b-badge>
          </div>
          <div v-else-if="row.item.estatus == 'Atendido'">
            <b-badge pill variant="secondary">{{row.item.estatus}}</b-badge>
          </div>
          <div v-else-if="row.item.estatus == 'En proceso'">
            <b-badge pill variant="warning">{{row.item.estatus}}</b-badge>
          </div>
          <div v-else-if="row.item.estatus == 'En espera'">
            <b-badge pill variant="warning">{{row.item.estatus}}</b-badge>
          </div>
          <div v-else-if="row.item.estatus == 'Cerrado'">
            <b-badge pill variant="success">{{row.item.estatus}}</b-badge>
          </div>

        </template>

        <template v-slot:row-details="row">
          <b-card>
            <ul v-for="(value, key) in images" :key="key">
              <!--row.item -->
              <li v-if=" value.ticket_id == row.item.id">
                <b-img thumbnail fluid :src="value.direccion" alt="imagen del ticket"></b-img>

              </li>
            </ul>
          </b-card>
        </template>
      
    
      </b-table>  
    </template>

  <script>
  import {mapActions,mapState,mapMutations} from 'vuex'
  import Multiselect from 'vue-multiselect'
  import customMixin from '@/mixins/customMixin'
  import { VueLoading } from 'vue-loading-overlay';

  export default {
    name:'ComponenteTabla',
    mixins : [customMixin],
    components: { Multiselect },
    props: {
      
      fields:{
        type: Array,
        required:true
      },
      height: {
        type: String,
        default: '60vh'
      },
      perPage:{
        type: Number,
      
      },
      currentPage:{
        type: Number,
        
      },
      isBusy:{
        type: Boolean,
        Default: false
      },
      images:{
          type:Array,
      },
      titulos:{
          type:Array,
          require: true
      },
      estados:{
          type:Array,
          require:true
      },
    },
      data: function(){
      return{
          
          datos:[],//se va  usar para la tabla y los filtros
          
          sortBy: '',
          sortDesc: false,
          sortDirection: 'asc',
          filter:'',
          filterOn: [],

          titulo:[],
          estado:[],
          

          useCustomIcons: true,
          sortIconNeutral:
          "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",
          sortIconDesc:
          "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",
          sortIconAsc:
          "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",

        
      }		
      },
      watch:{
          titulo: function() {
              if (!this.titulo.length && !this.estado.length ) {
                this.init()
                return  
              }
        
              if(this.estado.length){
                if(!this.titulo.length){
                  this.datos = this.filtroEstado(this.tickets, this.estado)  
                  return
                }else{
                  this.datos = this.filtroEstado(this.tickets, this.estado)
                  this.datos = this.filtroTitulo(this.datos,this.titulo)
                } 
              }  else {
                this.datos = this.filtroTitulo(this.tickets,this.titulo)
              }
              
          },
          estado: function(){
            console.log(this.estado)
            if (!this.estado.length && !this.titulo.length){
                this.init()
                return  
              }
            
              if(this.titulo.length){
                if(!this.estado.length){
                  this.datos = this.filtroTitulo(this.tickets,this.titulo)
                }else{
                  this.datos = this.filtroTitulo(this.tickets,this.titulo)
                  this.datos = this.filtroEstado(this.datos, this.estado)
                  
                }

              }else{
                this.datos = this.filtroEstado(this.tickets, this.estado)
              }
              
          }

      },
      mounted(){
      // this.init()
      },
      created() {
          this.init()
          
      },
      methods:{
        ...mapActions({
          _tickets: 'ticket/fetchTickets',
        }),

        
          init(){
            this._tickets().then(() => {      
            if(this.tickets.length > 0){
              this.datos = this.tickets
            }
            })//then
              
          },
          /**
          * Metodo que verifica si una orden esta cerrada y deshabilita el boton.
          */
          isDisabled(newVal){        
              if (newVal.estatus == 0)
                  return true
              
          },//isDisabled
          attendant(item, index,e){
              this.$emit('call-attendant', { item: item, index:index })
          },//attendant metodo emisor al padre
          
          
      },
      computed: {
        ...mapState('ticket',['tickets']),
        fieldKeys() {
              let keys = []
              for (let i = 0; i < this.fields.length; i++) { 
                  keys.push(this.fields[i]['key'])
              }
              return keys
        },
      
          
          
      }//computed
  }
  </script>

  <style lang="scss">
  /* Hide default icon */
  .b-th{
   
    vertical-align: top  !important;
    
    
  }
  </style>